module.exports = __webpack_public_path__ + "img/appoint_query.9d515e18.png";